import Lenis from 'lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

let lenis;

const init = () => {
    gsap.registerPlugin(ScrollTrigger);

    lenis = new Lenis({
        lerp: 0.10,
        smooth: true
    });

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time)=>{
        lenis.raf(time * 1000);
    });
}

const scrollToTop = () => {
    lenis.scrollTo(0, {
        duration: .8,
        easing: t => 1 - Math.pow(1 - t, 3)
    });
}

export default {
    init,
    scrollToTop
}
